const FORM_FACT_PATHS = [
  ["deals.manage.dealDescription", ["manage", "dealDescription"]],
  ["deals.calc.preCalc.sellerType", ["calc", "preCalc", "sellerType"]],
  ["deals.calc.preCalc.propertyType", ["calc", "preCalc", "propertyType"]],
  ["deals.calc.preCalc.soldPropertyDate", ["calc", "preCalc", "soldPropertyDate"]],
  ["deals.calc.preCalc.howPropertyIsSold", ["calc", "preCalc", "howPropertyIsSold"]],
  ["deals.calc.preCalc.totalPropertyCost", ["calc", "preCalc", "totalPropertyCost"]],
  ["deals.calc.preCalc.valueActualSoldOfProperty", ["calc", "preCalc", "valueActualSoldOfProperty"]],
  ["deals.calc.preCalc.iazamCombinationPercent", ["calc", "preCalc", "iazamCombinationPercent"]],
  ["deals.calc.preCalc.percentHoldingShares", ["calc", "preCalc", "percentHoldingShares"]],
  ["deals.calc.preCalc.hasZaban", ["calc", "preCalc", "hasZaban"]],
  ["deals.calc.preCalc.stepsBought", ["calc", "preCalc", "stepsBought"]]
];

for (let index = 0; index < 6; index++) {
  FORM_FACT_PATHS.push(
    ["deals.calc.preCalc.preCalcPartsData[" + index + "].percentBought", ["calc", "preCalc", "preCalcPartsData", index, "percentBought"]],
    ["deals.calc.preCalc.preCalcPartsData[" + index + "].wayOfGettingProperty", ["calc", "preCalc", "preCalcPartsData", index, "wayOfGettingProperty"]],
    ["deals.calc.mainCalc.deductions[" + index + "].deduDate", ["calc", "mainCalc", "deductions", index, "deduDate"]],
    ["deals.calc.mainCalc.deductions[" + index + "].amount", ["calc", "mainCalc", "deductions", index, "amount"]],
    ["deals.calc.mainCalc.deductions[" + index + "].deduCurrency", ["calc", "mainCalc", "deductions", index, "deduCurrency"]]
  );
}

function valueAt(object, path) {
  let current = object;
  for (const part of path) {
    if (!current || typeof current !== "object" || !(part in current)) return undefined;
    current = current[part];
  }
  return current;
}

function formFactValue(value) {
  if (typeof value === "string") return value.trim() ? value : undefined;
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "boolean") return value;
  return undefined;
}

// The lawyer's draft the assistant reads: the form, plus values the assistant accepted for fields the form cannot show
// yet (purchase rows before the analysis). A value the form holds always wins.
export function buildAssistantDealState(calc, manage, initialForm, defaultSuppressedFacts = new Set(), pendingFacts = []) {
  const form = { calc, manage };
  const pending = new Map(pendingFacts.map((fact) => [fact.path, fact.value]));
  return {
    schemaVersion: "AiDealStateV1",
    facts: FORM_FACT_PATHS.flatMap(([path, sourcePath]) => {
      const value = formFactValue(valueAt(form, sourcePath));
      if (value === undefined) return pending.has(path) ? [{ path, value: pending.get(path) }] : [];
      const initialValue = formFactValue(valueAt(initialForm || {}, sourcePath));
      const formDefault = value === initialValue && !defaultSuppressedFacts.has(path);
      return [{ path, value, ...(formDefault ? { formDefault: true } : {}) }];
    })
  };
}

export { FORM_FACT_PATHS };
